module.exports = __webpack_public_path__ + "static/media/summit-porter-logo-icon.57abe875.svg";